import React from 'react';
import './About.scss';
import images from '../../assets';

function About() {
    const tnValues = [
        {
            title: 'Integrity',
            description: 'We build trust through honest and ethical practices.',
            icon: 'integrity',
        },
        {
            title: 'Excellence',
            description:
                'We strive for perfection in every aspect of our work.',
            icon: 'excellence',
        },
        {
            title: 'Customer Focus',
            description:
                "We prioritize our clients' needs and exceed their expectations.",
            icon: 'customerFocus',
        },
        {
            title: 'Innovation',
            description: 'We stay at the forefront of industry advancements.',
            icon: 'innovation',
        },
    ];

    return (
        <>
            <section className="page-hero about-hero top-padding-mobile">
                <div className="page-hero-container">
                    <div className="page-hero-content">
                        <div className="page-hero-badge">About Us</div>
                        <h1 className="page-hero-title">Mechanical Partner for Civic Infrastructure</h1>
                        <p className="page-hero-description">
                            Topnotch Mechanical is a Toronto-based team focused on the buildings that serve our communities. We pair seasoned tradespeople with modern delivery methods to bring HVAC, plumbing, controls, and insulation solutions to schools, libraries, fire stations, and municipal facilities. Our commitment is simple: dependable systems, transparent communication, and work that respects the people who use these spaces every day.
                        </p>
                        <div className="page-hero-stats">
                            <div className="hero-stat-item">
                                <div className="stat-number">15+</div>
                                <div className="stat-label">Years Experience</div>
                            </div>
                            <div className="hero-stat-item">
                                <div className="stat-number">50+</div>
                                <div className="stat-label">Commercial Projects</div>
                            </div>
                            <div className="hero-stat-item">
                                <div className="stat-number">$50M+</div>
                                <div className="stat-label">Project Value</div>
                            </div>
                        </div>
                    </div>
                    <div className="page-hero-visual">
                        <svg width="280" height="280" viewBox="0 0 280 280" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <polygon points="140,40 220,100 220,180 140,240 60,180 60,100" stroke="rgba(0, 175, 207, 0.15)" strokeWidth="2" fill="none"/>
                            <polygon points="140,80 190,120 190,160 140,200 90,160 90,120" stroke="rgba(0, 175, 207, 0.2)" strokeWidth="2" fill="none"/>
                            <polygon points="140,120 170,140 170,160 140,180 110,160 110,140" fill="rgba(0, 175, 207, 0.08)"/>
                            <circle cx="140" cy="140" r="30" stroke="rgba(0, 175, 207, 0.2)" strokeWidth="2" fill="none"/>
                        </svg>
                    </div>
                </div>
            </section>

            <section className="section projects-section-main">
                <div className="container">
                    <div className="about-content-section">
                        <h2 className="page-title title">Who We Are</h2>
                        <p className="about-intro">
                            Topnotch Mechanical is a premier mechanical contracting company based in Toronto, Ontario, Canada. We specialize in delivering comprehensive mechanical solutions for large-scale commercial and institutional projects across the Greater Toronto Area. Our portfolio includes successful installations and renovations for school boards, municipalities, general contractors, and institutional clients, covering educational facilities, libraries, fire stations, community centers, and other public infrastructure projects. Our expertise spans HVAC systems, plumbing, building automation, and insulation, ensuring that every commercial project is completed with precision, efficiency, and adherence to the highest industry standards.
                        </p>
                    </div>
                </div>
            </section>

            <section className="section projects-section">
                <div className="mission-card">
                    <h3 className="page-title title">Our Mission</h3>

                    <div className="service-content-container">
                        <p className={'mission-content'}>
                            Our mission is to deliver exceptional mechanical services for commercial and institutional facilities that ensure optimal comfort, energy efficiency, and operational safety. We achieve this by combining our specialized expertise with the latest technologies and a commitment to meeting the unique requirements of school boards, municipalities, and general contractors. At Topnotch Mechanical, we believe in building long-lasting partnerships with institutional clients based on trust, integrity, and excellence in every project we undertake.
                        </p>
                    </div>
                </div>
            </section>

            <section className="section services-section">
                <div className="container">
                    <h3 className="page-title title">Our Values</h3>
                    <div className="section-content">
                        {tnValues?.map((item, index) => (
                            <div className="about-values-card" key={index}>
                                <img
                                    className="about-values-icon"
                                    src={images?.[item?.icon]}
                                    alt="topnotch"
                                    width="50"
                                />
                                <h3>{item?.title}</h3>
                                <p>{item?.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}

export default About;
